module.exports = __webpack_public_path__ + "static/media/navi.c6838270.png";